module.exports = __webpack_public_path__ + "static/UNITY-Square-Two-1st-floor-modern_v2-en-bd3895915628cc23f0c963d6163a989b.pdf";